function useRouteBack(history) {
  history.goBack();
}

export default useRouteBack;
